import { apiGetDomainLinkage } from '@/resource'

export default {
  async actionGetDomain({ commit, state }, rebateAccount) {
  return new Promise((resolve, reject) => {
    apiGetDomainLinkage({ rebateAccount })
      .then(result => {
        if (result.data.data) {
          commit('setDomainLinkage', result.data.data);
          resolve(result.data.data);
        } else {
          console.log('error');
          reject(new Error('No ibReferral data found'));
        }
      })
      .catch(error => {
        console.error('API error:', error);
        reject(error);
      });
  });
}
}